import { Manage } from 'config/commonTypes';
import {  useDispatch, useSelector } from 'react-redux';
import { updatePracticeData, resetEditbale, noSave } from '../actions/practiceDataUpdate';
import { RootState } from '../reducers';


export const usePracticeDataUpdateState = () => {
    const practiceDataUpdate = useSelector((state: RootState) => state.practiceDataUpdate);
    return practiceDataUpdate;
  };
  
  export const usePracticeDataUpdateDispatch = () => {
    const dispatch = useDispatch();
    return {updatePracticeData: (practiceDataUpdate: any) => dispatch(updatePracticeData(practiceDataUpdate)),
            resetEditbale: (flag: boolean) => dispatch(resetEditbale(flag)),
            noSave: (save: boolean) => dispatch(noSave(save))};
  };
